import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import AppContext from 'AppContext';

/**
 * Handles redirects from New ArcRegUi
 *
 * Test String:
 *   inbound/eyJEZXN0aW5hdGlvblBhZ2VVcmwiOiIvZGF0YS1tYW5hZ2VtZW50L2NsaWVudCIsIkNsaWVudENvZGUiOiJBU0kiLCJSZXBvcnRpbmdQZXJpb2QiOiIyMDIwLTEyLTMxIiwiQ2xpZW50TmFtZSI6IkFiZXJkZWVuIFN0YW5kYXJkIEludmVzdG1lbnRzIiwiQ2xpZW50VHlwZSI6IkFNIn0=
 *   {"DestinationPageUrl":"/data-management/client","ClientCode":"ASI","ReportingPeriod":"2020-12-31","ClientName":"Aberdeen Standard Investments","ClientType":"AM"}
 * 
 * @returns <Redirect>
 */
const Inbound = () => {
  const { handlers } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  const parsePayload = (pathname) => {
    try {
      const encodedPayload = pathname.replace('/inbound/', '');
      return JSON.parse(atob(encodedPayload));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Invalid inbound payload', error);
      return null;
    }
  };

  useEffect(() => {
    const receivedPayload = parsePayload(location.pathname);

    if (!receivedPayload?.DestinationPageUrl || !receivedPayload?.ClientCode) {
      navigate('/', { replace: true });
      return;
    }

    let isCancelled = false;

    const applyInboundStateAndNavigate = async () => {
      await handlers.setSelectedClient({
        name: receivedPayload.ClientName,
        type: receivedPayload.ClientType,
        code: receivedPayload.ClientCode,
      });

      if (isCancelled) {
        return;
      }

      if (!receivedPayload.ReportingPeriod) {
        await handlers.setSelectedReportingDate(null);
      } else {
        await handlers.setSelectedReportingDate({
          code: receivedPayload.ReportingPeriod,
          name: receivedPayload.ReportingPeriod,
          selected: true,
        });
      }

      navigate(receivedPayload.DestinationPageUrl, { replace: true });
    };

    applyInboundStateAndNavigate();

    return () => {
      isCancelled = true;
    };
  }, [handlers, location.pathname, navigate]);

  return null;
};

export default Inbound;
